export const generateNewRank = (
  existing?: { rank: string | number }[]
): number => {
  return existing && existing.length > 0
    ? Math.max(...existing.map((o) => Number.parseInt(String(o.rank)))) + 1
    : 0;
};
